import { render, staticRenderFns } from "./attachments-list.vue?vue&type=template&id=c6774122&scoped=true&"
import script from "./attachments-list.vue?vue&type=script&lang=js&"
export * from "./attachments-list.vue?vue&type=script&lang=js&"
import style0 from "./attachments-list.vue?vue&type=style&index=0&id=c6774122&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6774122",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
